'use es6';

import SenderAvatar from '../sender-avatar/SenderAvatar';
import { AGENT, VISITOR } from 'conversations-message-history/constants/messageUses';
import SenderMap from 'conversations-message-history/proptypes/SenderMap';
import RecordPropType from 'conversations-prop-types/prop-types/RecordPropType';
import PrimaryMessage from '../primary-message/components/PrimaryMessage';
import PrimaryMessageAvatar from '../primary-message/components/PrimaryMessageAvatar';
import PrimaryMessageContent from '../primary-message/components/PrimaryMessageContent';
import PrimaryMessageHeader from '../primary-message/components/PrimaryMessageHeader';
import PrimaryMessageHeaderContent from '../primary-message/components/PrimaryMessageHeaderContent';
import TypingHeaderContent from './TypingHeaderContent';
import { announce } from 'visitor-ui-component-library/utils/aria-live/AriaLiveAnnouncer';
import { useEffect } from 'react';
import I18n from 'I18n';
import { getSenderFromMessageSenders } from '../common-message/operators/getSenderFromMessageSenders';
import { isFromVisitor } from 'conversations-message-history/common-message-format/operators/senderTypeComparators';
import { isSenderLoading } from 'conversations-message-history/senders/operators/isSenderLoading';
import { getFirstName } from 'conversations-message-history/senders/operators/getters';
import GeneratingIndicator from '../atoms/GeneratingIndicator';
import FormattedMessage from 'I18n/components/FormattedMessage';
import getIn from 'transmute/getIn';
import { useSelector } from 'react-redux';
import { TYPING_MESSAGE_STYLE } from 'conversations-message-history/typing-indicator/records/TypingIndicatorMessage';
import PropTypes from 'prop-types';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const getTypingMessage = (style, isResponderAI) => {
  if (style === TYPING_MESSAGE_STYLE.STILL_THINKING) {
    return /*#__PURE__*/_jsx(FormattedMessage, {
      message: "conversations-visitor-message-history.stillThinkingMessage"
    });
  } else if (isResponderAI || style === TYPING_MESSAGE_STYLE.THINKING) {
    return /*#__PURE__*/_jsx(FormattedMessage, {
      message: "conversations-visitor-message-history.thinkingMessage"
    });
  } else {
    return /*#__PURE__*/_jsx(FormattedMessage, {
      message: "conversations-visitor-message-history.typingMessage"
    });
  }
};
const TypingIndicatorMessage = props => {
  const {
    message,
    senders,
    style = TYPING_MESSAGE_STYLE.TYPING
  } = props;
  const sender = getSenderFromMessageSenders(message, senders);
  const senderId = getIn(['id'], sender);

  // TODO: [GK] There has to be a better way to identify if the sender is an AI
  const isResponderAI = useSelector(state => {
    var _state$responders;
    return state === null || state === void 0 || (_state$responders = state.responders) === null || _state$responders === void 0 || (_state$responders = _state$responders.get('entries')) === null || _state$responders === void 0 || (_state$responders = _state$responders.find(a => a.getIn(['data', 'userId']) === parseInt(senderId, 10))) === null || _state$responders === void 0 ? void 0 : _state$responders.getIn(['data', 'isResponderAI']);
  });
  const isLoading = isSenderLoading(sender);
  const senderName = getFirstName(sender);
  const isVisitor = isFromVisitor(message);
  const use = isVisitor ? VISITOR : AGENT;
  useEffect(() => {
    if (!isVisitor) {
      announce(I18n.text('conversations-visitor-message-history.subjectIsTyping', {
        subject: senderName || I18n.text('conversations-visitor-message-history.agent')
      }));
    }
  }, [isVisitor, senderName]);
  return /*#__PURE__*/_jsxs(PrimaryMessage, {
    use: use,
    children: [/*#__PURE__*/_jsxs(PrimaryMessageHeader, {
      children: [/*#__PURE__*/_jsx(PrimaryMessageAvatar, {
        children: /*#__PURE__*/_jsx(SenderAvatar, {
          sender: sender,
          isLoading: isLoading
        })
      }), /*#__PURE__*/_jsx(PrimaryMessageHeaderContent, {
        children: /*#__PURE__*/_jsx(TypingHeaderContent, {
          message: message,
          sender: sender,
          isSenderLoading: isLoading
        })
      })]
    }), /*#__PURE__*/_jsx(PrimaryMessageContent, {
      style: {
        backgroundColor: 'transparent'
      },
      children: /*#__PURE__*/_jsx(GeneratingIndicator, {
        children: getTypingMessage(style, isResponderAI)
      })
    })]
  });
};
TypingIndicatorMessage.displayName = 'TypingIndicatorMessage';
TypingIndicatorMessage.propTypes = {
  message: RecordPropType('TypingIndicatorMessage').isRequired,
  senders: SenderMap.isRequired,
  style: PropTypes.oneOf(Object.values(TYPING_MESSAGE_STYLE))
};
export default TypingIndicatorMessage;